import Vue from 'vue';

import API from './index';

const END_POINT = 'restaurant';

export default {
  async getAll(): Promise<Restaurant[]> {
    try {
      return (await API.get(END_POINT)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/getAll`, err);
      return [];
    }
  },
  async getAllNearby({ latitude, longitude }: Coords): Promise<Restaurant[]> {
    try {
      return (await API.get(`${END_POINT}/near`, { params: { latitude, longitude } })).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/getAllNearby`, err);
      return [];
    }
  },
  async getOne(restaurantId) {
    try {
      return (await API.get(`${END_POINT}/${restaurantId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/getOne`, err);
    }
  },
  async getOneBySlug(slug) {
    try {
      return (await API.get(`${END_POINT}/single/${slug}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/getOne`, err);
    }
  },
  async getMenu(slug) {
    try {
      return (await API.get(`${END_POINT}/menu/${slug}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/getMenu`, err);
    }
  }
}
